import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { styled } from '@linaria/react';
import { mapEventChannel } from 'events/map';
import { AnimatePresence, motion } from 'framer-motion';
import { useScrollPosition } from 'hooks/useScrollPosition';
import { getUserAgentDetails } from 'modules/meta/selectors';
import { changeMapLayout, MapButtonPosition } from 'modules/search/actions/updateLayout';
import { getHotelId, getIsUserSearch } from 'modules/search/selectors';
import { MapDisplayAction } from 'modules/search/types';
import { getIsSearchBoxOpen } from 'modules/searchBox/selectors';
import getSafeBottomSpacingValue from 'utils/getSafeBottomSpacing';
import { Button } from '@daedalus/atlas/Button';
import { Icon } from '@daedalus/atlas/Icon';
import { cssTheme } from '@daedalus/atlas/themes';
import { trackEvent } from '@daedalus/core/src/analytics/modules/actions';
import { Action, Category, Entity } from '@daedalus/core/src/analytics/types/Events';
import FormattedMessageWrapper from '@daedalus/core/src/localization/components/FormattedMessage';
const _exp = /*#__PURE__*/() => motion.div;
const _exp2 = /*#__PURE__*/() => ({
  isSafari
}) => getSafeBottomSpacingValue({
  spacing: cssTheme.layout.spacing.s500,
  isSafari
});
const Wrapper = /*#__PURE__*/styled(_exp())({
  name: "Wrapper",
  class: "wwobdqp",
  propsAsIs: true,
  vars: {
    "wwobdqp-0": [_exp2()]
  }
});
const _exp3 = /*#__PURE__*/() => Button;
const FloatingButton = /*#__PURE__*/styled(_exp3())({
  name: "FloatingButton",
  class: "fzstgoz",
  propsAsIs: true
});
const MessageWrapper = /*#__PURE__*/styled('span')({
  name: "MessageWrapper",
  class: "m9swf7e",
  propsAsIs: false
});
export const ShowMapFloatingButton = () => {
  const {
    isSafari
  } = useSelector(getUserAgentDetails);
  const searchBoxIsOpen = useSelector(getIsSearchBoxOpen);
  const hotelIdFromUrl = useSelector(getHotelId);
  const isUserSearch = useSelector(getIsUserSearch);
  const [isFooterInView, setIsFooterInView] = useState<boolean>(false);
  useEffect(() => {
    const handleFooterInView = (inView: boolean) => {
      setIsFooterInView(inView);
    };
    mapEventChannel.on('footerInView', handleFooterInView);
    return () => {
      mapEventChannel.off('footerInView', handleFooterInView);
    };
  }, []);
  const dispatch = useDispatch();
  const {
    scrollY
  } = useScrollPosition();
  const onClick = useCallback(() => {
    dispatch(trackEvent({
      category: Category.User,
      entity: Entity.MapViewButton,
      action: Action.Clicked,
      component: MapButtonPosition.Floating
    }));
    dispatch(changeMapLayout(MapDisplayAction.SHOW, false));
  }, [dispatch]);
  const shouldShowButton = () => {
    if (searchBoxIsOpen) return false;
    if (hotelIdFromUrl && !isUserSearch && scrollY <= 0) return false;
    if (isFooterInView) return false;
    return true;
  };
  return <ShowMapFloatingButtonComponent onClick={onClick} isSafari={isSafari} shouldShowButton={shouldShowButton()} />;
};
interface Props {
  onClick: () => void;
  isSafari: boolean;
  shouldShowButton: boolean;
}
const ShowMapFloatingButtonComponent = React.memo(function ShowMapFloatingButtonComponent({
  onClick,
  isSafari,
  shouldShowButton
}: Props) {
  return <AnimatePresence>
        {shouldShowButton && <Wrapper key="show-map-floating-button" isSafari={isSafari} initial={{
      opacity: 0,
      y: '200%',
      x: '-50%'
    }} animate={{
      opacity: 1,
      y: 0,
      x: '-50%'
    }} exit={{
      opacity: 0,
      y: '200%',
      x: '-50%'
    }}>
            <FloatingButton variant="inverse" isRounded size="xl" iconStart={<Icon name="Map" />} onClick={onClick} isFloating dataId="mobileMapButton">
              <MessageWrapper>
                <FormattedMessageWrapper id="map" defaultMessage="Map" />
              </MessageWrapper>
            </FloatingButton>
          </Wrapper>}
      </AnimatePresence>;
});

require("./ShowMapFloatingButton.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./ShowMapFloatingButton.tsx");